<div class="dialog-header">
  <div class="header-title"><span style="font-size: 125%;">{{headerString}}</span></div>

  <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content timesheet-dialog" [ngClass]="{'disabled-content': loadingSpinner}">

  <form #timeEditForm="ngForm">
    <div class="form-block">
      <div class="form-row">
        <div class="icon-block">
          <mat-icon>person</mat-icon>
        </div>
        <div class="field-block">
          <p-dropdown [options]="users"
                      [(ngModel)]="selectedUser"
                      [filter]="true"
                      filterBy="name,username,shortCode,phone,email"
                      placeholder="Select User"
                      optionLabel="name"
                      appendTo="body"
                      panelStyleClass="vacation-dropdown-panel"
                      [disabled]="!!timeCard || !(currentUser.adminNSuperV)"
                      (onChange)="onUserChange($event)"
                      (onShow)="calendarIsShown()"
                      (onHide)="calendarIsClosed()">
          </p-dropdown>
        </div>
      </div>
      <div class="form-row stat-row" *ngIf="buttonLabel === 'Request'">
        <div class="field-block user-stat-field">
          <div class="vacation-stats-table">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Carryover</th>
                  <th>Accrued</th>
                  <th>Used</th>
                  <th *ngIf="editMode">Correction</th>
                  <th>Remaining</th>
                </tr>
              </thead>
              <tbody>
                <tr class="sick-row" [class.selected]="selectedVacation.name === 'SICK_HOURS'" (click)="!editMode && selectVacationType(vacationTypes[1])">
                  <td class="type-label">Sick Time Off</td>
                  <td>{{editMode ? vacationStats?.carryoverSickDays : vacationStats?.carryoverSickDays + vacationStats?.correctionSickDays}}</td>
                  <td>{{vacationStats?.accruedSickDays}}</td>
                  <td>{{vacationStats?.usedSickDaysApproved}}</td>
                  <td *ngIf="editMode">
                      <input *ngIf="editMode" type="number" [(ngModel)]="editedSick" [ngModelOptions]="{standalone: true}" class="accrued-input">
                  </td>
                  <td>{{vacationStats?.availableSickDays}}</td>
                </tr>
                <tr class="vacation-row" [class.selected]="selectedVacation.name === 'VACATION'" (click)="!editMode && selectVacationType(vacationTypes[0])">
                  <td class="type-label">Vacation</td>
                  <td>{{editMode ? vacationStats?.carryoverVacationDays : vacationStats?.carryoverVacationDays + vacationStats?.correctionVacationDays}}</td>
                  <td>{{vacationStats?.accruedVacationDays}}</td>
                  <td>{{vacationStats?.usedVacationDaysApproved}}</td>
                    <td *ngIf="editMode">
                        <input *ngIf="editMode" type="number" [(ngModel)]="editedVacation" [ngModelOptions]="{standalone: true}" class="accrued-input">
                    </td>
                  <td>{{vacationStats?.availableVacationDays}}</td>
                </tr>
                <tr class="unpaid-row" [class.selected]="selectedVacation.name === 'UNPAID_VACATION'" (click)="!editMode && selectVacationType(vacationTypes[2])">
                  <td class="type-label">Unpaid PTO</td>
                  <td>--</td>
                  <td>--</td>
                  <td>{{vacationStats?.usedUnpaidVacationDaysTotal}}</td>
                  <td *ngIf="editMode">--</td>
                  <td>--</td>
                </tr>
              </tbody>
            </table>
            <div class="stats-footer">
              <div class="stats-buttons">
                <button *ngIf="currentUser?.adminRole && !editMode" mat-button class="edit-stats-button" (click)="enableEditMode()">Edit</button>
                <button *ngIf="currentUser?.adminRole && editMode" mat-button class="cancel-stats-button" (click)="cancelEditMode()">Cancel</button>
                <button *ngIf="currentUser?.adminRole && editMode" mat-button class="save-stats-button" (click)="saveVacationStats()">Save</button>
              </div>
              <div class="stats-footer-right">
                <div class="stats-note" *ngIf="vacationStats">{{ vacationStats?.workedHrs }} hours worked.</div>
                <i class="pi pi-info-circle time-off-info-icon" (click)="showTimeOffInfo($event)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row" *ngIf="buttonLabel !== 'Request'">
        <div class="icon-block">
          <mat-icon>list</mat-icon>
        </div>
        <div class="field-block">
          <mat-select [(value)]="selectedVacation" [disabled]="buttonLabel !== 'Request'">
            <mat-select-trigger>{{selectedVacation.title}}</mat-select-trigger>
            <mat-option *ngFor="let vacationType of vacationTypes" [value]="vacationType">
              <span class="type-text">{{vacationType.title}}</span>
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="form-row" *ngIf="buttonLabel !== 'Request'">
        <div class="label-block">
          <!-- <mat-icon>alarm</mat-icon> -->
          Start
        </div>
        <div class="field-block calendar-block">
          <p-calendar [(ngModel)]="startDate" view="date" [tabindex]="-1" type="date" readonly="readonly"
                      [disabled]="rejected"
                      [touchUI]="true" name="startDate" [showIcon]="true" [ngModelOptions]="{standalone: true}"
                      (onShow)="calendarIsShown()" (onClose)="calendarIsClosed()" [readonlyInput]="false"
                      [showOnFocus]="false">
          </p-calendar>
        </div>
      </div>
      <div class="form-row" *ngIf="buttonLabel === 'Request'">
          <div class="icon-block">
              <mat-icon>date_range</mat-icon>
          </div>
        <div class="field-block calendar-block">
          <p-calendar [(ngModel)]="dates" view="date" [tabindex]="-1" type="date" readonly="readonly"
                      selectionMode="multiple" [touchUI]="true" name="dates" [showIcon]="true"
                      [ngModelOptions]="{standalone: true}" (onShow)="calendarIsShown()"
                      (onClose)="calendarIsClosed()" [readonlyInput]="false" [showOnFocus]="false"
                      placeholder="Choose Dates">
          </p-calendar>
        </div>
      </div>
    </div>
    <div class="save-btn-block">
      <div class="reject-box">

        <!--        <button *ngIf="buttonLabel !== 'Request' && !rejected" mat-button class="reject-item-button"-->
        <!--                (click)="rejectTimeCard()">-->
        <!--          <span *ngIf="!rejectLoadingSpinner">Reject</span>-->
        <!--          <lib-mini-progress-spinner *ngIf="rejectLoadingSpinner"></lib-mini-progress-spinner>-->
        <!--        </button>-->

        <i #infoIconHover *ngIf="rejected && overlayPanelMessage" class="pi pi-info-circle reject-info-icon"
           (click)="vacationRejectPanel.toggle($event)" ></i>
      </div>

      <button mat-button class="save-btn" (click)="saveTimeButton()"
              [disabled]="disableSaveButton || (!dates && !startDate) || rejected" tabindex="1" type="submit"
              [ngClass]="{'disabled-button': disableSaveButton || (!dates && !startDate) || rejected}">
        <span *ngIf="!loadingSpinner">{{getButtonLabel()}}</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>

      <div class="flex-box">
        <button *ngIf="buttonLabel !== 'Request'" mat-button class="delete-item-button"
                (click)="deleteTimeCard()">
          <mat-icon *ngIf="!deleteLoadingSpinner">delete</mat-icon>
          <lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
        </button>
      </div>
    </div>
  </form>
</div>

<p-overlayPanel #vacationRejectPanel appendTo="body" styleClass="vacation-reject-op-block">
  <ng-template pTemplate>
    {{overlayPanelMessage}}
  </ng-template>
</p-overlayPanel>

<p-overlayPanel #timeOffInfoPanel appendTo="body" styleClass="time-off-info-panel">
  <ng-template pTemplate>
      <div class="time-off-info-content">
          <h3>How Time Off Works</h3>

          <div class="info-section">
              <h4>Vacation Time</h4>
              <p>You may have up to <strong>10 vacation days</strong> remaining at any time</p>
              <p>You accrue <strong>1 vacation hour for every {{ 2080 / selectedUser?.annualVacationHours || 0}} hours worked</strong></p>
              <p>Unused vacation hours carried into the next year, <strong>up to the 10-day limit</strong></p>
          </div>

          <div class="info-section">
              <h4>Sick Time</h4>
              <p>There is <strong>no limit on the total sick time</strong> remaining</p>
              <p>You accrue <strong>1 sick hour for every 40 hours worked</strong></p>
              <p>Up to <strong>5 unused sick days</strong> may be carried into the next year</p>
          </div>

          <div class="info-section">
              <h4>Using Time Off</h4>
              <p>Time off must be taken in <strong>full days only</strong></p>
              <p>One day off equals <strong>8 hours</strong></p>
              <p>Partial days are not allowed</p>
          </div>

          <div class="info-section">
              <h4>Good to Know</h4>
              <p>The table follows the formula: <strong>Carryover + Accrued - Used = Remaining</strong></p>
              <p>All values in the table are shown as <strong>full days</strong>. Decimal values are stored but not shown</p>
          </div>
      </div>
  </ng-template>
</p-overlayPanel>

